import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=daf591f8&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=daf591f8&scoped=true&lang=scss"
import style1 from "./shop.vue?vue&type=style&index=1&id=daf591f8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf591f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daf591f8')) {
      api.createRecord('daf591f8', component.options)
    } else {
      api.reload('daf591f8', component.options)
    }
    module.hot.accept("./shop.vue?vue&type=template&id=daf591f8&scoped=true", function () {
      api.rerender('daf591f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/configure/shop.vue"
export default component.exports